import { Input } from "@visiblethread/react-components";
import ListInput from "components/ListInput";
import { arrayOf, func, string } from "prop-types";

import classes from "./StructureEditor.module.scss";

// Presentational tier + reorderable-groups editor for the type-review gate.
// The Input component's onChange contract is (value, event) — not the usual
// event-first signature — and its `label`/`id` props render a real <label
// htmlFor>, so no separate label element is needed for accessible naming.
const StructureEditor = ({ tierLabel, groups, onChange }) => {
  const handleTierChange = (value) => onChange({ tierLabel: value, groups });

  const handleGroupsChange = (nextGroups) =>
    onChange({ tierLabel, groups: nextGroups });

  return (
    <div className={classes.editor} data-testid="structure-editor">
      <Input
        id="structure-tier"
        label="Top-Level Tier"
        value={tierLabel}
        onChange={handleTierChange}
        placeholder="e.g. Volume, Part, Section — leave blank for a flat outline"
      />

      <span className={classes.label}>Top-Level Groups</span>
      <ListInput
        content={groups}
        setContent={handleGroupsChange}
        ariaLabel="Add a top-level group"
      />
    </div>
  );
};

StructureEditor.propTypes = {
  tierLabel: string.isRequired,
  groups: arrayOf(string).isRequired,
  onChange: func.isRequired,
};

export default StructureEditor;
